import { Component, OnInit } from '@angular/core';
import { IconBaseComponent } from '../icon-base/icon-base.component';

@Component({
  selector: 'app-icon-sort-arrow-down',
  templateUrl: './icon-sort-arrow-down.component.html',
  styleUrls: ['./icon-sort-arrow-down.component.scss']
})
export class IconSortArrowDownComponent extends IconBaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
